var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { FormPropertyFactory } from "./angular2-schema-form-shim";
import { NumberProperty as _NumberProperty } from "angular2-schema-form/src/model/numberproperty";
import { StringProperty as _StringProperty } from "angular2-schema-form/src/model/stringproperty";
import { BooleanProperty as _BooleanProperty } from "angular2-schema-form/src/model/booleanproperty";
import { ObjectProperty as _ObjectProperty } from "angular2-schema-form/src/model/objectproperty";
import { ArrayProperty as _ArrayProperty } from "angular2-schema-form/src/model/arrayproperty";
export function PropertyOverrides(base) {
    return (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _this = _super.apply(this, args) || this;
            _this.checkSchema();
            // Object and Array properties pass the first property as
            if (args[0] instanceof FormPropertyFactory) {
                var formPropertyFactory = args.shift();
            }
            _this.schemaValidatorFactory = args[0];
            var parent = args[3];
            var path = args[4];
            _this.schemaValidator = _this.extendValidator(_this.schemaValidatorFactory.createValidatorFn(_this.schema));
            return _this;
        }
        class_1.prototype.checkSchema = function () {
            if (!this.schema)
                throw new Error('Property has no schema');
            if (!('options' in this.schema))
                this.schema.options = {};
        };
        class_1.prototype.extendValidator = function (schemaValidatorFn) {
            var _this = this;
            return function (value) {
                var err = schemaValidatorFn(value);
                if (err && err.length) {
                    // Ignore errors on hidden properties
                    err = err.filter(function (error) {
                        var property = _this.searchProperty(error.path.substring(1));
                        return !property || property.visible;
                    });
                }
                return err || null;
            };
        };
        class_1.prototype._runValidation = function () {
            var _this = this;
            if (this.isObject)
                _super.prototype._runValidation.call(this);
            var errors = this.schemaValidator(this.value) || [];
            var customValidators = this.validatorRegistry.get(this.path);
            if (customValidators && !this.schemaValidatorFactory.isPropertyMissing(this.value, this.schema)) {
                // Remove null child properties, fix numeric types
                var cleanedValue_1 = this.schemaValidatorFactory.cleanupValue(this.value, this.schema);
                var customErrors = customValidators.map(function (customValidator) { return customValidator(cleanedValue_1, _this, _this.findRoot()); });
                errors = this.mergeErrors(errors, customErrors);
            }
            if (errors.length === 0) {
                errors = null;
            }
            this._errors = errors;
            this.setErrors(this._errors);
        };
        class_1.prototype.mergeErrors = function (errors, newErrors) {
            if (newErrors) {
                if (Array.isArray(newErrors)) {
                    errors = errors.concat.apply(errors, newErrors);
                }
                else {
                    errors.push(newErrors);
                }
                errors = this.uniqueErrors(errors);
            }
            return errors;
        };
        class_1.prototype.uniqueErrors = function (errors) {
            // Errors are unique based on the path and code
            var uniqueErrorMap = {};
            errors.forEach(function (error) { return error && (uniqueErrorMap[error.path + "\n" + error.code] = error); });
            return Object.values(uniqueErrorMap);
        };
        // Make sure the abstract methods are defined
        class_1.prototype.setValue = function (value, onlySelf) {
            base.prototype.setValue.call(this, value, onlySelf);
        };
        class_1.prototype.reset = function (value, onlySelf) {
            base.prototype.reset.call(this, value, onlySelf);
        };
        class_1.prototype._hasValue = function () {
            return base.prototype._hasValue.call(this);
        };
        class_1.prototype._updateValue = function () {
            base.prototype._updateValue.call(this);
        };
        class_1.prototype.exportValue = function () {
            // We don't actually want to override this method, just provide a stub to prevent errors.
            if ('exportValue' in base.prototype) {
                return base.prototype.exportValue.call(this);
            }
            else {
                return this.value;
            }
        };
        return class_1;
    }(base));
}
var NumberProperty = (function (_super) {
    __extends(NumberProperty, _super);
    function NumberProperty() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NumberProperty = __decorate([
        PropertyOverrides
    ], NumberProperty);
    return NumberProperty;
}(_NumberProperty));
export { NumberProperty };
var StringProperty = (function (_super) {
    __extends(StringProperty, _super);
    function StringProperty() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StringProperty = __decorate([
        PropertyOverrides
    ], StringProperty);
    return StringProperty;
}(_StringProperty));
export { StringProperty };
var BooleanProperty = (function (_super) {
    __extends(BooleanProperty, _super);
    function BooleanProperty() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BooleanProperty = __decorate([
        PropertyOverrides
    ], BooleanProperty);
    return BooleanProperty;
}(_BooleanProperty));
export { BooleanProperty };
var ArrayProperty = (function (_super) {
    __extends(ArrayProperty, _super);
    function ArrayProperty() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArrayProperty = __decorate([
        PropertyOverrides
    ], ArrayProperty);
    return ArrayProperty;
}(_ArrayProperty));
export { ArrayProperty };
var ObjectProperty = (function (_super) {
    __extends(ObjectProperty, _super);
    function ObjectProperty() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isObject = true;
        return _this;
    }
    ObjectProperty.prototype.exportValue = function () {
        var value = {};
        for (var propertyName in this.schema.properties) {
            value[propertyName] = typeof this._value[propertyName] === 'undefined'
                ? null
                : this._value[propertyName];
        }
        return value;
    };
    ObjectProperty = __decorate([
        PropertyOverrides
    ], ObjectProperty);
    return ObjectProperty;
}(_ObjectProperty));
export { ObjectProperty };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/formproperty.ts.pre-build-optimizer.js